<template>
  <div id="userCenter">
    <!-- 搜索 -->
    <div class="flex justify-end align-center" style="height: 32px;">
      <el-input @input='clearSear' @change='searchDev' style="width: 320px;" placeholder="请输入设备码" v-model="search" class="input-with-select">
      </el-input>
      <i @click="searchDev" style="position: absolute; right: 50px; top: 32px;color: #000000;font-size: 16px;cursor: pointer;" class="el-icon-search"></i>
    </div>
    <!-- 分界线 -->
    <div class="" style="height: 10px;background-color: #F5F6FA;width: 100%;margin-top: 16px;margin-bottom: 24px;"></div>

    <div class="flex flex-direction justify-between" style="min-height: 780px;">
      <div class="">
        <!-- 表格 -->
        <el-table id="userCenter_table" :data="tableData" :row-class-name="tableRowClassName" style="width: 100%">
          <el-table-column type="index" fixed="left" align="center" label="序号" width="80">
          </el-table-column>
          <el-table-column prop="dev" align="center" label="设备码" width="300">
          </el-table-column>
          <el-table-column prop="sysinfo" align="center" label="设备信息" width="300">
          </el-table-column>
          <el-table-column prop="version_number" align="center" label="初次使用版本" width="150">
          </el-table-column>
          <el-table-column prop="server_time" align="center" label="服务结束时间" width="180">
          </el-table-column>
          <el-table-column prop="create_time" align="center" label="设备创建时间" width="180">
          </el-table-column>
          <el-table-column prop="last_ip" align="center" label="最近使用IP" width="150">
          </el-table-column>
          <el-table-column prop="last_city" align="center" label="IP所属城市" width="150">
          </el-table-column>
          <el-table-column prop="last_open_time" align="center" label="最近启动时间" width="180">
          </el-table-column>
          <el-table-column prop="last_version_number" align="center" label="最近使用版本" width="150">
          </el-table-column>
          <el-table-column prop="count_use_time" align="center" label="累计在线时长" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.count_use_time | transforTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="count_open_row" align="center" label="累计启动次数" width="150">
          </el-table-column>
          <el-table-column prop="count_data_row" align="center" label="累计算价次数" width="150">
          </el-table-column>
<!--          <el-table-column prop="online" align="center" label="当前是否在线" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row | online }}</span>
            </template>
          </el-table-column> -->

          <el-table-column fixed="right" align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-button :class="scope.row.active?'':'nocolor'" @click.native.prevent="deleteRow(scope.row.id, scope.row.active)" type="text" size="small">
                {{scope.row | operation}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination id='pagebox' style="margin-top: 30px;text-align: center;" background
        @current-change="handleCurrentChange" :current-page="tablePage" :page-size="tableLimit" :page-sizes="[100, 200, 300, 400]"
        layout="total, prev, pager, next, jumper" :total="tableCount">
      </el-pagination>
    </div>

    <!-- 备注弹框 -->
      <el-dialog id="bigBox" title="外层 Dialog" :visible.sync="outerVisible">
        <!-- 内层 -->
        <el-dialog
          id="smallBox"
          width="30%"
          title="添加备注"
          :visible.sync="innerVisible"
          append-to-body>
          <p style="color: #333333;font-size: 14px;text-align: left;margin-bottom: 6px;">备注</p>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="Remark.content">
          </el-input>

          <div class="flex justify-end align-center" style="margin-top: 30px;">
            <el-button @click="closeBz" style="padding: 0 20px;height: 32px;background-color: #F5F6F7;margin-right: 16px;">取消</el-button>
            <el-button @click='sendRequest' style="padding: 0 20px;height: 32px;background-color: #1BADE8;color: #FFFFFF;">提交</el-button>
          </div>
        </el-dialog>

       <div class="flex justify-between align-center" style="border-bottom: 1px solid #EEEEEE;padding-bottom: 14px;">
          <p class="titlep">备注</p>
          <div class="flex align-center">
            <el-button @click="innerVisible=true" class="btn_">添加备注</el-button>
            <i @click="outerVisible=false" class="el-icon-close" style="font-size: 24px;color: #D8D8D8;margin-left: 70px;cursor: pointer;"></i>
          </div>
        </div>
        <!-- 空状态 -->
        <el-empty v-show="remarkList.length=='0'" description="暂无数据"></el-empty>
        <!-- 数据列表 -->
        <div class="" v-for="(item,index) in remarkList" :key='index'>
          <p style="color: #C0BEBE;font-size: 14px;text-align: left;margin-bottom: 8px;margin-top: 16px;">{{item.create_time}}</p>
          <div class="" style="background-color: #F5F6F7;min-height: 100px;text-align: left;padding: 16px;box-sizing: border-box;">
            <span style="font-weight: 700;font-size: 14px;color: #333333;">备注：</span>
            {{item.content}}
          </div>
        </div>

        <el-pagination slot="footer" style="margin-top: 30px;text-align: center;" background
          @current-change="handleCurrentChange_" :current-page="remarkPage" :page-size='remarkLimit' :page-sizes="[100, 200, 300, 400]"
          layout="total, prev, pager, next, jumper" :total="remarkCount">
        </el-pagination>
      </el-dialog>
  </div>

</template>

<script>
  export default {
    name: 'userCenter',
    created() {
      this.getTable()
    },
    data() {
      return {
        outerVisible:false,//备注外层弹框
        innerVisible:false,//备注内层弹框
        search: '',//搜索
        /* 获取表格数据发送参数 */
        sendData:{
          act:'userDev',
          page:1,
          limit:10
        },
        /* 渲染页面参数 */
        tablePage:1,//表格--当前页
        tableLimit:10,//表格--当前页数据条数尺寸
        tableCount:10,//表格--数据总条数
        tableData: [],//表格--数据列表

        /* 获取备注列表请求参数 */
        remarkData:{
          act:'userRemarkList',
          id:'',
          page:1,
          limit:10
        },
        remarkList:[],
        remarkPage:1,
        remarkLimit:10,
        remarkCount:1,
        /* 添加备注请求参数 */
        Remark:{
          act:'userRemark',
          id:'',
          content:''
        }

      }
    },
    filters:{
      /* 是否在线 */
      online(value){
        let isOnline='否'
        if(value.online){
          isOnline='是'
        }
        return isOnline
      },
      /* 在线时长转换 */
      transforTime(value){
            const hour = parseInt(value / 3600) < 10 ? '0' + parseInt(value / 3600) : parseInt(value / 3600)
            const min = parseInt(value % 3600 / 60) < 10 ? '0' + parseInt(value % 3600 / 60) : parseInt(value % 3600 / 60)
            const sec = parseInt(value % 3600 % 60) < 10 ? '0' + parseInt(value % 3600 % 60) : parseInt(value % 3600 % 60)
            let strTime = hour + '小时' + min + '分钟' + sec+'秒'
            return strTime
      },
      /* 操作显示 */
      operation(value){
        if(!value.active) return '未激活'
        if(value.active&&value.remark) return '查看'
        if(value.active&&!value.remark) return '添加'
      }
    },
    methods: {
            tableRowClassName({row, rowIndex}) {
              if (row.online) {
                return 'success-row';
              }
              return '';
            },


      /******************* 获取数据列表 */
      getTable(){
        this.$api.dataList.userTable(this.sendData).then(res=>{
          // console.log(res)
          if(res.code=='1'){
            this.tablePage=res.data.page
            this.tableLimit=res.data.limit
            this.tableCount=res.data.count
            this.tableData=res.data.list
          }
        })
      },
      /******************* 切换页面  */
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.sendData.page=val
        this.getTable()
      },
      /***********************表格操作--添加、查看备注 */
      deleteRow(id, active) {
        //console.log(id,active)
        if(!active) return false;
        this.remarkData.id=id
        this.Remark.id=id
        this.outerVisible=true
        this.remarkList.page=1
        this.userRemarkList()
      },

      /* 获取备注列表 */
      userRemarkList(){
        this.$api.dataList.userTable(this.remarkData).then(res=>{
          //console.log('备注列表：',res)
          if(res.code=='1'){
            this.remarkPage=res.data.page
            this.remarkLimit=res.data.limit
            this.remarkCount=res.data.count
            this.remarkList=res.data.list
          }
        })
      },
      /* 备注列表分页 */
      handleCurrentChange_(val){
        this.remarkList.page=val
        this.userRemarkList()
      },
      /* 取消备注 */
      closeBz(){
        this.innerVisible=false
      },
      /* 添加备注 */
      sendRequest(){
        this.$api.dataList.userTable(this.Remark).then(res=>{
          //console.log('添加备注：',res)
          if(res.code=='1'){
            this.$message({
              message: res.info,
              type: 'success'
            })
            this.innerVisible=false
            this.remarkList.page=1
            this.userRemarkList()
          }else{
            this.$message({
              message: res.info,
              type: 'error'
            })
          }
        })
      },
      /* 搜索 */
      searchDev(){
        if(!this.search) return false

        this.$api.dataList.userTable({
          act:'userDev',
          dev:this.search
        }).then(res=>{
          //console.log('搜索：',res)
          if(res.code='1'){
            this.tablePage=res.data.page
            this.tableLimit=res.data.limit
            this.tableCount=res.data.count
            this.tableData=res.data.list
          }else{
            this.$message({
              message: res.info,
              type: 'error'
            })
          }
        })
      },
      clearSear(e){
        //console.log(e)
        if(e!='') return false
        this.sendData.page=1
        this.getTable()
      }
    }
  }
</script>

<style>
  #userCenter {
    background-color: #FFFFFF;
    padding: 24px;
    border-radius: 6px;
    position: relative;
  }
  /****************************/
  /* 备注 */
  #bigBox .el-dialog,
  #smallBox .el-dialog{
    border-radius: 8px;
  }
  #bigBox .el-dialog__header{
    display: none;
  }
  #bigBox .el-dialog__body{
    padding: 24px;
    min-height: 400px;
  }
 #bigBox .titlep{
    color: #000;
    font-size: 14px;
    text-align: left;
    font-weight: 700;
  }
  #bigBox .btn_{
    height: 32px;
    color: #FFFFFF;
    padding: 0 20px;
    background-color: #1BADE8;
  }
  #smallBox .el-dialog__title{
    color: #000000;
    font-weight: 700;
    font-size: 14px;
  }
  #smallBox .el-dialog{
    padding:24px;
  }
  #smallBox .el-dialog__header{
    border-bottom: 1px solid #EEEEEE;
  }

  /* 未激活 */
  .nocolor{
    color: #666666 !important;
  }

  /* 是否在线 */
    .el-table .success-row {
      background:#66b1ff;
      color:#FFFFFF
    }

    #userCenter .el-table .el-table__body tr:hover td {
        color: black;
    }
</style>



// WEBPACK FOOTER //
// src/components/userCenter.vue